// extracted by mini-css-extract-plugin
module.exports = {"Address":"Address_Address__2UrxN"};